import { useNavigate } from 'react-router-dom';
import { ROUTE_LABS_ORDER_STEP_2 } from '../../../../constants/routes';
import { LabsOrderStepLayout, FeatureTag } from '../components';

export function Step1Summary() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate(ROUTE_LABS_ORDER_STEP_2);
  };

  return (
    <LabsOrderStepLayout currentStep={1}>
      <div className="space-y-6">

      {/* Lab Panel Card */}
      <div className="rounded-[40px] p-10" style={{ background: 'linear-gradient(180deg, rgba(201, 238, 254, 0.00) 0%, rgba(202, 239, 255, 0.50) 99.99%, #CBEFFF 100%), #F0F5F6' }}>
        {/* Blood test vials illustration */}
        <div className="mb-6 flex justify-center">
          <div className="relative h-[146px] w-full max-w-[453px]">
            <img
              src="/images/blood-panel-vials.png"
              alt="Blood test vials illustration"
              className="h-full w-full object-contain"

            />
          </div>
        </div>

        {/* Title */}
        <h2 className="mb-4 text-left text-[24px] font-semibold leading-[140%] tracking-[-0.5px] text-[#183344]">
          Catch Labs Blood Panel
        </h2>

        {/* Divider */}
        <div className="mx-auto mb-4 h-px w-full bg-gray-300"></div>

        {/* Description */}
        <p className="mb-8 text-left text-[16px] leading-[170%] text-[#3B3B3B] opacity-80">
          A comprehensive annual blood test designed to give you a clear picture of your overall health.
        </p>

        {/* Features Section */}
        <div>
          <h3 className="mb-4 text-[20px] font-semibold leading-[31px] text-gray-900">Features:</h3>

          {/* Feature Tags */}
          <div className="flex flex-wrap gap-2">
            <FeatureTag>50+ biomarkers</FeatureTag>
            <FeatureTag>immune health</FeatureTag>
            <FeatureTag>metabolic health</FeatureTag>
            <FeatureTag>inflammatory markers.</FeatureTag>
            <FeatureTag>clinician-reviewed results</FeatureTag>
          </div>
        </div>
      </div>

        {/* Get Started Button */}
        <div className="flex justify-center pt-4">
          <button
            onClick={handleGetStarted}
            className="w-full rounded-full bg-[#7CF1C7] px-8 py-3.5 text-center text-[17px] font-bold leading-[26px] text-[#183344] transition-all hover:scale-105 hover:shadow-lg"
          >
            Get Started
          </button>
        </div>
      </div>
    </LabsOrderStepLayout>
  );
}
